import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteeTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'dateActioned',
];

const optionalColumnLabelFormat = {
  dateActioned: 'Date Actioned',
};

const DeclinedGuarantees = ({ TabsRaw }: any) => (
  <GuaranteeTableRecords
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.declinedGuaranteesRoute}
    tabStatus="CANCELLED"
    toggleStorageId="declined-guarantee-table-col"
    hasNameAndImage
    permissionName="can-view-declined-guarantees"
  />

);

export default DeclinedGuarantees;
